import {adicRestApi, adicRestApiAdUrl, adicRestApiMypageUrl} from '../index';

export const getMyAdWatchViewList = async (query) => {
  const url = adicRestApiMypageUrl
    .segment("/watch-history")
    .query(query)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const postMyAdWatchViewList = async (reqBody = {}) => {
  const url = adicRestApiMypageUrl
    .segment("/watch-history")
    .toString();

  const { data } = await adicRestApi.post(url, reqBody);
  return data;
};

export const removeMyAdWatchViewList = async (id = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/watch-history/:id`)
    .param(id)
    .toString();

  const { data } = await adicRestApi.delete(url, id);
  return data;
};

export const removeAllMyAdWatchViewList = async (userId = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/watch-history/all/:userId`)
    .param(userId)
    .toString();

  const { data } = await adicRestApi.delete(url, userId);
  return data;
};

export const getMyAdLikeViewList = async (query) => {
  const url = adicRestApiMypageUrl
    .segment("/like-history")
    .query(query)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const postMyAdLikeViewList = async (reqBody = {}) => {
  const url = adicRestApiMypageUrl
    .segment("/like-history")
    .toString();

  const { data } = await adicRestApi.post(url, reqBody);
  return data;
};

export const removeLikedList = async (id = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/liked/:id`)
    .param(id)
    .toString();

  const { data } = await adicRestApi.delete(url, id);
  return data;
};

export const removeAllLikedList = async (userId = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/liked/all/:userId`)
    .param(userId)
    .toString();

  const { data } = await adicRestApi.delete(url, userId);
  return data;
};

export const getAdicPlayList = async (query) => {
  const url = adicRestApiMypageUrl
    .segment("/playlist")
    .toString();
  const { data } = await adicRestApi.get(url);
  return data;
};

export const postAdicPlayList = async (reqBody = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/playlist`)
    .toString();

  const { data } = await adicRestApi.post(url, reqBody);
  return data;
};

export const removeAdicPlayList = async (id = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/playlist/:id`)
    .param(id)
    .toString();

  const { data } = await adicRestApi.delete(url, id);
  return data;
};

export const getAdicPlayListAd = async (query) => {
  const { playlistId } = query
  if (!playlistId || playlistId.length === 0) {
    return [];
  }
  const url = adicRestApiMypageUrl
    .segment("/playlist/ad")
    .query(query)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const postAdicPlayListAd = async (reqBody = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/playlist/ad`)
    .toString();

  const { data } = await adicRestApi.post(url, reqBody);
  return data;
};

export const removeAdicPlayListAd = async (id = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/playlist/ad/:id`)
    .param(id)
    .toString();

  const { data } = await adicRestApi.delete(url);
  return data;
};

export const registerDevice = async (device = {}) => {
  const url = adicRestApiMypageUrl
    .segment("/push-devices")
    .toString();

  const { data } = await adicRestApi.post(url, device);
  return data;
};

export const getAlarmSettings = async (reqBody = {}) => {
  const url = adicRestApiMypageUrl
    .segment("/settings/alarm")
    .toString();

  const { data } = await adicRestApi.post(url, reqBody);
  return data;
};

export const updateAlarmSettings = async (reqBody = {}) => {
  const url = adicRestApiMypageUrl
    .segment("/settings/alarm")
    .toString();

  const { data } = await adicRestApi.put(url, reqBody);
  return data;
};

export const postAdicApplication = async (reqBody = {}) => {
  const url = adicRestApiMypageUrl
    .segment(`/playlist/application`)
    .toString();
  try {
    const { data } = await adicRestApi.post(url, reqBody);
    return data;
  }
  catch (e) {
    const code = (e.response.data && e.response.data.code) || e.code;
    return e.response.data;
  }
};
